import headers from './headers'

export default function(fetch) {
  return function() {
    const apiResources = fetch(
      `${process.env.REACT_APP_API_URL}/orders/${localStorage.getItem('order_id')}/backgrounds`,
      {
        headers: headers(),
        method: 'GET',
      }
    )
    const systemResources = fetch('/mocks/walls.json')

    return Promise.all([apiResources, systemResources])
      .then(([api, system]) => Promise.all([api.json(), system.json()]))
      .then(([api, system]) => [...api, ...system])
  }
}



// WEBPACK FOOTER //
// ./src/repositories/getWallpapers.js